module.exports = __webpack_public_path__ + "img/otsar-large.20fde039.jpg";